/** Internal network codes → human-readable blockchain names (Wikipedia list). */
const BLOCKCHAIN_DISPLAY_NAMES: Record<string, string> = {
  BTC: 'Bitcoin',
  ETH: 'Ethereum',
  TRC20: 'TRON',
  TRON: 'TRON',
};

export const formatNetworkLabel = (network: string | null | undefined): string => {
  if (!network) {
    return '—';
  }

  return BLOCKCHAIN_DISPLAY_NAMES[network.toUpperCase()] ?? network;
};

export const formatCurrencyNetworkLabel = (currency: string, network: string): string =>
  `${currency} · ${formatNetworkLabel(network)}`;

export const TRC20_NETWORK_OPTION = {
  value: 'TRC20',
  label: formatNetworkLabel('TRC20'),
} as const;

export const ETH_NETWORK_OPTION = {
  value: 'ETH',
  label: formatNetworkLabel('ETH'),
} as const;

export const TRON_NETWORK_OPTION = {
  value: 'TRON',
  label: formatNetworkLabel('TRON'),
} as const;

export const BTC_NETWORK_OPTION = {
  value: 'BTC',
  label: formatNetworkLabel('BTC'),
} as const;
